import { createMuiTheme } from '@material-ui/core/styles'
// find full object data here: https://material-ui.com/customization/default-theme/

const BORDER_COLOR = 'rgb(218, 220, 224)'

const theme = createMuiTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#36AB91',
      // dark: will be calculated from palette.primary.main,
      contrastText: '#fff',
    },
    secondary: {
      main: '#715B9A',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#fff',
    },
  },
  typography: {
    display4: {
      fontSize: '4rem',
    },
  },
  overrides: {
    MuiInput: {
      underline: {
        '&:before': {
          borderBottomColor: BORDER_COLOR,
        },
        '&:hover:not(.Mui-disabled):before': {
          borderBottomColor: BORDER_COLOR,
        },
      },
    },
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: BORDER_COLOR,
      },
    },
  },
})

export default theme
